const storageKey = (userId: string) => `gamma:get-app-banner-dismissed:${userId}`;

export const isGetAppBannerDismissed = (userId: string) => {
  try {
    return localStorage.getItem(storageKey(userId)) === 'true';
  } catch {
    return false;
  }
};

export const markGetAppBannerDismissed = (userId: string) => {
  try {
    localStorage.setItem(storageKey(userId), 'true');
  } catch {
    // Storage can be unavailable (private mode, blocked site data); the banner then only stays
    // closed until the next reload.
  }
};
